import { WithEnterpriseId, WithOwnerId } from '@mews-commander/types';
import { useRepositoryQuery } from '@mews-commander/data-access';

export const useDashboardCorrections = ({ ownerId, enterpriseId }: WithOwnerId & WithEnterpriseId) =>
    useRepositoryQuery(
        'corrections',
        'getAllByOwnerIds',
        { ownerIds: [ownerId], enterpriseId },
        { refetchOnMount: 'always' }
    );
